import { API_URL } from "settings";
import { toast } from "react-toastify";
import l from "components/util/l";

const downloadFile = (url, blob = null, name = '') => {

  if (!blob && !url) throw new Error("Either url or blob must be provided");

  getBlob(url, blob, (finalBlob) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(finalBlob);
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  });

}

const getBlob = (url, blob, callback) => {
  if (blob) callback(blob);
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = () => {
    const blob = xhr.response;
    callback(blob);
  };
  xhr.send();
}

const uploadFile = ({ callback, multiple = false, accept = '*' }) => {

  const input = document.createElement("input");
  input.multiple = multiple;
  input.type = "file";
  input.style.display = "none";
  input.accept = accept;

  input.onchange = async (e) => {

    const files = e.target.files;
    if (files.length === 0) return;

    const results = [];

    for (const file of files) {

      try {

        const res = await callUploadFile(file);

        if (res.ok)
          results.push(res.body);
        else
          toast.error(l("Ha ocurrido un error al subir el archivo {file_name}%GA090", { file_name: file.name }));

      } catch (error) {
        toast.error(l("Ha ocurrido un error al subir el archivo {file_name}%GA090", { file_name: file.name }));
      }

    }

    callback(results);

  }

  document.body.appendChild(input);
  input.click();

}

const callUploadFile = async (file) => {

  let url = `${API_URL}/files/`;
  let formData = new FormData();
  formData.append("file", file);

  let res = await fetch(url, {
    cache: "no-cache",
    method: "POST",
    headers: {
      "Authorization": `Token ${sessionStorage.getItem("token")}`
    },
    body: formData
  });

  let json = await res.json();
  return {
    body: json,
    ok: res.status === 200 || res.status === 201
  }

}

export { downloadFile, uploadFile }